import { render, staticRenderFns } from "./DataSourceFields.vue?vue&type=template&id=02cdf19a&"
import script from "./DataSourceFields.vue?vue&type=script&lang=js&"
export * from "./DataSourceFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports